import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function BillingSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    
    // Give user 3s to see confirmation, then redirect
    const timer = setTimeout(() => {
      navigate("/admin?checkout=success");
    }, 3000);

    // Set loading to false after a brief moment
    const loadingTimer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => {
      clearTimeout(timer);
      clearTimeout(loadingTimer);
    };
  }, [navigate, searchParams]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <div className="loading-spinner"></div>
        <p>Processing your payment...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-2xl font-bold text-green-600">✅ Payment Successful!</h1>
      <p className="mt-2 text-gray-700">Your license purchase has been completed successfully.</p>
      <p className="mt-1 text-gray-600">Redirecting you back to your dashboard...</p>
    </div>
  );
}
